import { render, staticRenderFns } from "./TheMenu.vue?vue&type=template&id=c53a65a8&scoped=true&"
import script from "./TheMenu.vue?vue&type=script&lang=js&"
export * from "./TheMenu.vue?vue&type=script&lang=js&"
import style0 from "./TheMenu.vue?vue&type=style&index=0&id=c53a65a8&lang=scss&scoped=true&"
import style1 from "./TheMenu.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53a65a8",
  null
  
)

export default component.exports